import React from 'react';
import { forEach as _forEach } from 'lodash';

export default class Img extends React.Component {
  getThumbSrc = file => {
    let thumbFile;

    _forEach(file.variations || file.getVariations(), variation => {
      if (
        (variation.variation_type && variation.variation_type === 'thumb') ||
        (variation.getVariationType && variation.getVariationType() === 'thumb')
      ) {
        thumbFile = variation.file || variation.getFile();
      }
    });

    if (thumbFile) {
      return thumbFile.web_link || thumbFile.getWebLink();
    }
  };

  render() {
    const { file } = this.props;
    return <div class="image" style={{ background: 'url(' + this.getThumbSrc(file) + ')' }} />;
  }
}
